export interface Player {
  id: number;
  name: string;
  ready: boolean;
}

export const demoInitialPlayerNames: string[] = []; // or ["Alice", "Bob", "Carol"]
